'use client';

import Slider from 'components/gruenland/atoms/slider/Slider';
import Module01Slide, { Module01SlideProps } from './Module01Slide';

export type Module01Props = {
  slides: Array<Module01SlideProps>;
};

export const Module01 = ({ slides }: Module01Props) => {
  return (
    <Slider arrows arrowsPosition="hero" dots dotsPosition="hero">
      {slides.map((x, i) => (
        <Module01Slide key={i} {...x} />
      ))}
    </Slider>
  );
};
